import { observer } from 'mobx-react-lite';
import { parseDate } from '../../utils/utils';
import styles from '../Grid.module.css';

function EditableGrid<T>({ values, headers, getId, onChange }: IEditableGridProps<T>) {

    return (
        <table className={styles.grid}>
            <thead>
                <tr>
                    {headers.map(h => (
                        <th key={getHeaderKey(h)} className={getAlignClassName(h.align || "center")}>
                            {h.titleStrings.map(ts => <div key={ts}>{ts}</div>)}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {values.map(item => (
                    <tr key={getId(item)}>
                        {headers.map(h => (
                            <td key={getHeaderKey(h)} className={getAlignClassName(h.align || "center")}>
                                <input type={h.valueType} value={h.getValue(item)} onChange={e => {
                                    if (h.valueType === InputType.Text) {
                                        h.setValue(item, e.target.value);
                                    } else if (h.valueType === InputType.Number) {
                                        h.setValue(item, e.target.valueAsNumber);
                                    } else if (h.valueType === InputType.Date) {
                                        h.setValue(item, parseDate(e.target.value));
                                    }

                                    onChange(item);
                                }} />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

const getHeaderKey = <T,>(header: IHeader<T>) => header.titleStrings.join(" ");

const getAlignClassName = (align: "left" | "center" | "right") => {
    switch (align) {
        case "left": return styles.alignLeft;
        case "center": return styles.alignCenter;
        case "right": return styles.alignRight;
    }
};

export default observer(EditableGrid);

interface IEditableGridProps<T> {
    values: T[];
    headers: IHeader<T>[];
    getId: (item: T) => any;
    onChange: (item: T) => void;
}

export interface IHeader<T> {
    titleStrings: string[];
    align?: "left" | "center" | "right";
    getValue: (item: T) => any;
    getLabel: (item: T) => string;
    setValue: (item: T, value: any) => void;
    valueType: InputType
}

export enum InputType {
    Text = "text",
    Number = "number",
    Date = "date",
}